// extracted by mini-css-extract-plugin
export default {"main":"MyProfileUpdateLayout_main__UOYkh","container":"MyProfileUpdateLayout_container__lWNYt"};